function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function ChevronUpIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    d: "M4 16.0854L12 8L20 16.0854L18.5541 17.3333L12 10.7095L5.44589 17.3333L4 16.0854Z",
    fill: "currentColor"
  }));
}
export function ChevronUpIconSmall(props) {
  return ___EmotionJSX(ChevronUpIcon, _extends({
    size: "small"
  }, props));
}